<template src="./index.html"></template>
<script>
import minhead from '../../../common/minHead/index.vue';
import CompanySetting from './CompanySetting/index.vue';
import LoginSetting from './LoginSetting/index.vue';
import ContentsSetting from './ContentsSetting/index.vue';
import { getdata as fromlistdata } from '../zzsz/CompanySetting/data.js';
import configHttp from '../../../../../configHttp.js';
import bus from '../../../../components/util/bus.js';
import importFile from './importFile/index.vue';
import { getdata } from './data.js';
import {
	groupList,
	saveNode,
	saveorganization,
	getDqSelect,
	getByDqform,
	logins,
	getByDqSflx,
	deles,
	updates,
	queryNode,
	shenBContent,
	company,
	LoginRegisterType, //登录注册类型
	loginInfo, //根据id获取报税登录详情
	SshyTree, //获取所属行业
	information, //j基础信息编辑
	companyLoginInfo, //税务编辑
	login
} from '../../../../api/organization.js';
export default {
	inject: ['reload'],
	name: 'zzsz',
	components: {
		minhead,
		CompanySetting,
		LoginSetting,
		ContentsSetting,
        importFile
	},
	data: function() {
		return {
			activeSearch: '', //搜索框信息
			companysend: 0, //用于确定点的是新建还是修改
			tablekey: 0,
			deptType: '', //节点类型
			codegoole: '', //点击搜索赋值
			input: '', //新增节点输入框
			renameInput: '', //重命名输入框双向绑定数据
			ancestors: [], //当前节点的父级关联关系（id）
			parentNames: [], //当前节点的父级关联关系（名称）
			adresslists: [], // 城市下拉选框接口
			loginSlist: [], //个人登录信息下拉列表
			headData: getdata().headData,
			tableData: getdata().tableData,
			pagination: getdata().pagination,
			data: [],
			defaultProps: {
				children: 'children',
				label: 'label'
			},
			choosetreeid: '',
			shaidiag: false,
			//新建节点
			createNodediag: false,
			//重命名
			reNamediag: false,
			//基础设置
			right_tableData: [], //右边列表信息
			companySettingdiag: false,
			LoginSettingdiag: false,
			ContentsSettingdiag: false,
			formlist: fromlistdata().formlist,
			formdata: fromlistdata().formdata,
            rpaFormData: {},
			ruleForm: fromlistdata().ruleForm,
			ruledata: [],
			parentId: '',
			outtableData: [],
			DqSflx: [], //身份类型下拉列表
			outlist: [], //穿梭狂的左边
			outtableDatabody: [], //获取申报内容
			title: '',
			allowDrag: null,
			allowDrop: null,
			one: '',
			suoshy: [],
			companyId: '',
            rowData: {},
            importFileFlag: false,
            province: []
		};
	},
	mounted() {},
	created() {
		this.FileLists()

		 //获取登录注册类型
		let a = this.one.split(',');
	},
	methods: {
		acit(e) {},
		//11111111111111111		新增公司
		getDqSelects() {
			// 城市下拉选框接口
			getDqSelect().then(res => {
                if (res.data.data == "" || res.data.data == null) {
                    this.$message.error(res.data.msg);
                } else {
                    this.adresslists = res.data.data;
                    this.province = this.adresslists;
                    if (this.companysend == 0) {
                        this.outchanges({
                            prop: 'dq',
                            value: this.adresslists[0].value
                        });
                    } else {
                        this.outchanges({
                            prop: 'dq',
                            value: this.formdata.dq
                        });
                    }
                }
			});
		},
		outchanges(e) {
			//切换城市重新获取表单
			if (e.prop == 'dq') {
				this.formdata.dq = parseFloat(e.value);
				this.loginding(); // 登录方式下拉选框接口
			} else {
				this.uplist(); // 动态获取表格
			}
		},
		async loginding() {
			// 登录方式下拉选框接口
			const one = await this.identity(); // 身份类型下拉选框接口
			if (one) {
				const two = await this.login_log();
				if (two) {
					this.uplist();
				}
			}
		},
		uplist() {
			// 动态获取表格
			let params = {
				dqCode: this.formdata.dq + '-' + this.formdata.dlfs
			};
			getByDqform(params).then(res => {
				if (res.data.data) {
					let arrayNew = res.data.data.map(item => {
						let obj = {
							prop: item.column,
							label: item.name,
							isnotnull: true,
							type: item.column == 'sflx' || item.column == '个人登录方式' || item.column == 'sbtd' ? 'select' : 'input',
							placeholder:item.column == 'dlzh'?'居民身份证号码/手机号码/用户名':item.column == 'gryhmm'?'个人用户密码(初始密码为证件号码后六位)':''
						};
						if (item.column == 'sflx') {
							obj.selectval = this.DqSflx; //复制下拉列表
						}
                        if (item.column == 'sbtd') {
                            obj.selectval = [
                                {
                                    label: "RPA",
                                    value: "RPA"
                                },
                                {
                                    label: "QXY",
                                    value: "QXY"
                                }
                            ];
                        }
						if (item.column == 'grdlfs') {
							obj.selectval = [
								{
									label: '用户名登陆',
									value: 1
								}
							];
						}
						return obj;
					});

					this.formlist[1].selectval = this.loginSlist;
					this.formlist[0].selectval = this.adresslists;
					arrayNew.unshift(this.formlist[1]);
					arrayNew.unshift(this.formlist[0]);
					this.formlist = JSON.parse(JSON.stringify(arrayNew));
					this.companySettingdiag = true;
					setTimeout(v => {
						this.formdata.grdlfs = 1;
					}, 0);
					if (this.formlist.length % 2 != 0) {
						this.formlist.push({ prop: 'inputs' });
					}
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		login_log() {
			//个人登录信息
			return new Promise((resolve, reject) => {
				let params = {
					dqCode: this.formdata.dq
				};
				logins(params).then(res => {
					if (res.data.code == 1) {
						this.loginSlist = res.data.data;
						// if (this.companysend == 0) {

						this.formdata.dlfs = this.loginSlist[0].value;
						// }
						resolve(true);
					} else {
						this.$message.error(res.data.msg);
					}
				});
			});
		},
		identity() {
			// 身份类型下拉选框接口
			return new Promise((resolve, reject) => {
				let params = {
					dqCode: this.formdata.dq
				};
				getByDqSflx(params).then(res => {
					if (res.data.code == 1) {
						this.DqSflx = res.data.data;
						resolve(true);
					} else {
						this.$message.error(res.data.msg);
					}
				});
			});
		},
		saveding() {
			//点击新建公司

			this.companysend = 0; //用于确定点的是新建还是修改
			Object.keys(this.formdata).map(key => {
				if (key == 'dq' || key == 'dlfs' || key == 'grdlfs') {
				} else {
					this.formdata[key] = '';
				}
			});
			Object.keys(this.ruleForm).map(key => {
				this.ruleForm[key] = '';
			});
			this.getDqSelects(); // 城市下拉选框接口
			this.title = '基础信息';
		},

		//-----------

		fun(value) {
			value.map(item => {
				item.label = item.gbbmmc;
				item.value = item.id;
				if (item.children != null && item.children.length != 0) {
					this.fun(item.children);
				} else {
					delete item.children;
				}
			});
		},


		shyTree() {
			//所属行业下拉
			SshyTree().then(res => {
				if (res.data.code == 1) {
					this.ruledata.Industry = res.data.data;
					this.fun(this.ruledata.Industry);
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		func(value, id, key) {
			if (id != null) {
				value.map(item => {
					if (item.children) {
						this.func(item.children, id, key + ',' + item.id);
					}
					if (item.children && item.children.length == 0) {
						delete item.children;
					}
					if (item.id == id) {
						return (this.suoshy = key.split(',').splice(1, key.length - 1));
					}
				});
			}
		},

		LoginType() {
			//获取登记注册类型下拉
			LoginRegisterType().then(res => {
				if (res.data.code == 1) {
					this.ruledata.loginType = res.data.data;
					this.shyTree();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		dragleave(draggingNode, dropNode, ev) {
		},
		forupdatecompany(e) {
			this.companyId = String(e.companyId);
			this.companysend = 1; //用于确定点的是新建还是修改
			let params = {
				companyId: e.companyId
			};
			company(params).then(res => {
				if (res.data.code == 1) {
					let outlist = [];
					this.ruledata.Industry.map(item => {
						outlist.push({ ...item });
					});
					this.func(outlist, res.data.data.company.suoshy);
					this.suoshy.push(res.data.data.company.suoshy);
					this.suoshy.map((item, index) => {
						this.suoshy[index] = parseInt(item);
					});
					res.data.data.company.suoshy = this.suoshy;
					this.ruleForm = res.data.data.company;
					if (this.ruleForm.shifyx == '1') {
						this.ruleForm.shifyx = false;
					} else {
						this.ruleForm.shifyx = true;
					}

					this.outtableData = res.data.data.companyChildren;
					this.title = '基础信息';
					this.companySettingdiag = true;
				} else {
					this.message.error(res.data.msg);
				}
			});
		},

		//-----------

		//11111111111111111		添加节点

		active() {
			//添加节点确认
			if (!this.$emptyandnull(this.input)) {
				this.parentNames.push(this.input);
				let params = {
					ancestors: this.ancestors.join(','),
					parentId: this.choosetreeid,
					parentNames: this.parentNames.join('-'),
					deptType: 0,
					name: this.input
				};
				saveNode(params).then(res => {
					if (!this.$emptyandnull(res.data.data)) {
						this.createNodediag = false;
						this.FileLists();
					} else {
						this.$message.error(res.data.msg);
					}
				});
			} else {
				this.$message.error('名称为空');
			}
		},
		remonves() {
			//删除节点
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					let params = {
						deptType: this.deptType, //节点类型
						id: this.choosetreeid //节点id
					};
					deles(params).then(res => {
						//调用删除接口
						if (res.data.code == 1) {
							this.$message.success('删除成功');
							this.FileLists(); //删除成功重新左边获取列表
						} else {
							this.$message.error(res.data.msg);
						}
					});
				}
			});
		},

		//-----------

		//11111111111111111		左侧列表

		FileLists() {
			//左侧获取列表
			groupList().then(res => {
				if (res.data.code == 1) {
					this.data = res.data.data || [];
                    if (!this.data.length) {
                        this.choosetreeid = ''; this.right_tableData = []; this.pagination.total = 0;
                        return;
                    }
                    this.nodeQuery(this.data[0].id);
					this.choosetreeid = this.data[0].id;
					this.forchooseitem('', this.data[0]);
				 	this.LoginType()
				} else {
				 this.$message.error(res.data.msg);
				}
			});
		},
		forchooseitem(node, data) {
			//点击列表中的某一项获取到的数据
			this.renameInput = data.name; //节点名称赋值
			this.deptType = data.deptType; //节点类型
			this.companyId = data.companyId;
			this.choosetreeid = data.id;
			if (data.parentNames) {
				this.parentNames = data.parentNames.split('-'); //当前节点的父级关联关系（名称）
			}
			if (data.ancestors) {
				this.ancestors = data.ancestors.split(','); //当前节点的父级关联关系（id）
			}
			this.ancestors.push(this.choosetreeid); //push当前id
			this.nodeQuery(); //调用分页查询
		},
		sizechange(e) {
			//页码切换
			this.pagination.pageSize = e;
			this.nodeQuery(); //调用分页查询
		},
		currentChange(e) {
			//页码切换
			this.pagination.pageNum = e;
			this.nodeQuery(); //调用分页查询
		},
		nodeQuery(e) {
            if (!e && !this.choosetreeid) { this.right_tableData = []; this.pagination.total = 0; return; }
			//分页查询
			let params = {
				current: this.pagination.pageNum,
				deptId: this.choosetreeid || e,
				size: this.pagination.pageSize,
				search: this.activeSearch //搜索框信息
			};
			queryNode(params).then(res => {
				if (res.data.code == 1) {
					this.right_tableData = res.data.data.records; //右边列表信息
					this.pagination.total = parseFloat(res.data.data.total);
					if (this.activeSearch != this.codegoole) {
						//判断是否点击了搜索
						this.codegoole = this.activeSearch; //没有点击重置输入框到上次搜索内容   可以直接清空
					}
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		clickSearch() {
			//点击搜索
			this.activeSearch = JSON.parse(JSON.stringify(this.codegoole)); //点击了搜索按钮赋值用于比对是否点击搜索
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.nodeQuery(); //调用搜索按钮
		},
		ExportList() {
			let params = {
				downUrl: configHttp.baseURL + '/sys/export/list',
				typeObj: {
					toForm: false,
					fileType: 'xlsx',
					failUrl:this.$winURl
				},
				params: {
					current: this.pagination.pageNum,
					deptId: this.choosetreeid || '',
					size: this.pagination.pageSize,
					search: this.activeSearch //搜索框信息
				}
			};
			this.$downloadcommon(params);
		},
		//11111111111111111		报税登录编辑
		forlogin(e) {
			this.companyId = String(e.companyId)
            this.rowData = e;
			let params = {
				companyId: e.companyId
			};
			loginInfo(params).then(res => {
				if (res.data.code == 1) {
					this.title = '报税登录';
					this.companysend = 2; //用于确定点的是新建还是修改或者报税登录
					if (res.data.data == null) {
						this.formdata.dq = '';
					} else {
						this.formdata = res.data.data.companyLoginInfo;
                        if (res.data.data.gatewayInfo) {
                            this.rpaFormData = res.data.data.gatewayInfo;
                            this.rpaFormData.province = Number(this.rpaFormData.province);
                        } else {
                            this.rpaFormData = {};
                        }
					}
					this.getDqSelects();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		onchange() {
			this.forcontent({
				companyId: this.one
			});
		},
		forcontent(e) {
			//点击申报内容  获取申报内容
			this.one = e.companyId;
			let params = {
				companyId: this.one
			};
			shenBContent(params).then(res => {
				if (res.data.code == 1) {
					this.outtableDatabody = res.data.data;
					this.outtableDatabody[0].ides = e.companyId;
					this.ContentsSettingdiag = true;
				} else {
					this.message.error(res.data.msg);
				}
			});
		},
		closeCompanySettingdiag(e) {
			this.companySettingdiag = false;
		},
		confirm(e, rpa) {
			//提交按钮新增公司	//修改
            if (this.data && this.data.length > 0){
                rpa.customerId = this.data[0].id
                rpa.companyId = this.companyId;
                rpa.companyName = this.rowData.nsrmc;
                rpa.taxpayerId = this.rowData.nsrsbh;
            }
			if (this.companysend == 0) {
                // 新建
				//push公司名称为拼接公司父级关系后端需要
				let cont = {
					parentNames: `${this.parentNames}-${e.nsrmc}`,
					ancestors: this.ancestors.join(','),
					parentId: this.choosetreeid
				};
				let params = {
					...cont,
					...e
				};
				saveorganization(params).then(res => {
					if (res.data.code == 1) {
						this.$message.success('新增成功');
						this.FileLists(); //新增完成重新调用查询
						this.companySettingdiag = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			} else if (this.companysend == 1) {
                // 修改
				if (e.shifyx == false) {
					e.shifyx = 1;
				} else {
					e.shifyx = 0;
				}
				information(e).then(res => {
					if (res.data.code == 1) {
						this.$message.success('修改成功');
						this.FileLists(); //新增完成重新调用查询
						this.companySettingdiag = false;
					} else {
						this.$message.error(res.msg);
					}
				});
			} else {
                // 报税登录
				let obj = JSON.parse(JSON.stringify(e));
				obj.grdlfs = JSON.stringify(obj.grdlfs);
				obj.dq = JSON.stringify(obj.dq);
				delete e.hidden;
				companyLoginInfo({companyLoginInfo:obj, gatewayInfo: rpa}).then(res => {
					if (res.data.code == 1) {
						this.$message.success('修改成功');
						this.companySettingdiag = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			}
		},
		closeLoginSetting() {
			this.LoginSettingdiag = false;
		},
		closeContentsSettingdiag() {
			this.ContentsSettingdiag = false;
		},
		forback() {
			this.$router.go(-1);
		},
		rename(e) {
			//重命名数据反向渲染
			this.parentId = e.parentId;
			this.reNamediag = true;
		},
		renamenext() {
			//重命名
			if (this.renameInput == '' || this.renameInput == null) {
				this.$message.error('不能为空');
			} else {
				let params = {
					name: this.renameInput,
					id: this.choosetreeid
				};
				updates(params).then(res => {
					if (res.data.code == 1) {
						if (this.parentId === '0') {
							bus;
							let setuserInfo = JSON.parse(localStorage.getItem('userInfo'));
							setuserInfo.parentName = this.renameInput;
							localStorage.setItem('userInfo', JSON.stringify(setuserInfo));
							this.reload();
						}
						this.$message.success('修改成功');
						this.FileLists();
						this.reNamediag = false;
					} else {
						this.message.error(res.data.msg);
					}
				});
			}
		},
		closeshaidiag(e) {
			this.shaidiag = false;
		},
		confirmfilter() {},
        importCompany(){
            this.importFileFlag = true;
        },
        closeImportFileDialog(){
            this.importFileFlag = false;
        },
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
@import url('@/assets/css/tree.less');
</style>
